import React from 'react'

import ConfirmationDetails from './Common/ConfirmationDetails'
import ExtraDetails from './Common/ExtraDetails'
import StartAndEndPlaces from './Common/StartAndEndPlaces'
import SummaryImage from './Common/SummaryImage'
import DefaultSummaryModalFooter from './Common/SummaryModalFooter/DefaultSummaryModalFooter'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import GooglePlaceRating from 'tripPlanner/components/GooglePlaceRating/GooglePlaceRating'
import BookedLabel from 'tripPlanner/components/BookedLabel'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import { ItemMetadata } from 'tripPlanner/models'
import type { ThingToDoItem } from 'tripPlanner/types/tripItem'
import { maybePlaceId } from 'tripPlanner/utils'
import { getDisplayableCustomThingToDoName } from 'tripPlanner/utils/itemConversions/common'

interface Props {
  item: ThingToDoItem
}

function ThingTodoItemSummary(props: Props) {
  const { item } = props

  const isSameEndPlace =
    'id' in item.startPlace &&
    'id' in item.endPlace &&
    item.startPlace.id &&
    item.startPlace.id === item.endPlace.id

  const placeId = maybePlaceId(item.startPlace)

  const { closeModal, goBack } = useModalCallbacks()

  return (
    <>
      <ModalHeader
        title={getDisplayableCustomThingToDoName(item)}
        subtitle={
          isSameEndPlace || !item.endPlace.name ?
            item.startPlace.name :
            `Starts in ${item.startPlace.name}, Ends in ${item.endPlace.name}`
        }
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />

      <ModalBody>
        <SummaryImage
          place={item.startPlace}
          tripId={item.tripId}
          tripItemId={item.id}
        />
        <ModalContent>
          <VerticalSpacer gap={20}>
            <Group direction="horizontal" horizontalAlign="space-between">
              <Heading variant="heading6">
                {ItemMetadata[item.type].singularName}
              </Heading>
              {item.isBooked && <BookedLabel />}
            </Group>
            <StartAndEndPlaces item={item} />
            {placeId && (
              <GooglePlaceRating placeId={placeId} size="M" label="Reviews" />
            )}
            <ConfirmationDetails
              isBooked={item.isBooked}
              confirmationCode={item.confirmationCode}
              price={item.price}
            />
            <ExtraDetails
              url={item.url}
              phone={item.phone}
              notes={item.notes}
            />
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>

      <DefaultSummaryModalFooter item={item} />
    </>
  )
}

export default ThingTodoItemSummary
